import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/login');
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!res.ok) throw new Error('Auth failed');
        const user = await res.json();

        // Redirect to admin dashboard with user data
        navigate('/admin', { state: { user }, replace: true });
      } catch (err) {
        console.error('Auth error:', err);
        navigate('/admin/login');
      }
    };

    exchangeSession();
  }, [navigate]);

  return null;
}
